export const FORM_ACTION_LABELS = {
  CREATE_SUPPLY_REQUEST: 'Order supplies',
  CREATE_TASK: 'Create a task',
};

export const friendlyFormAction = (type) => FORM_ACTION_LABELS[type] || 'Start workflow';

export const humanizeKey = (key = '') => String(key)
  .replace(/([a-z])([A-Z])/g, '$1 $2')
  .replace(/[_-]+/g, ' ')
  .replace(/^./, (char) => char.toUpperCase());

export const readableSubmissionEntries = (data = {}, fields = []) => {
  const labelByKey = new Map(fields.map((field) => [field.key || field.name, field.label || humanizeKey(field.key || field.name)]));
  return Object.entries(data || {}).map(([key, value]) => ({
    label: labelByKey.get(key) || humanizeKey(key),
    value: Array.isArray(value) ? value.join(', ') : String(value ?? ''),
  }));
};